module.exports = __webpack_public_path__ + "static/seo-fitness-mobile-solution-b-1e3a1172cfd49e0c4d917e5b1149d9c2.png";